import { removeUndefinedFields } from "../helper";

export const QUESTIONS = (electricalSystemDetails) => [
  {
    label: "Battery details",
    apiKey: "batteryStaticVoltageObserved",
    options: [
      {
        label: "Battery Static Voltage (VDC) observed",
        type: "INPUT",
        keyboardType: "numeric",
        apiOptionKey: "batteryStaticVoltageObserved",
      },
      {
        label: "Battery Voltage during Cranking observed",
        type: "INPUT",
        keyboardType: "numeric",
        apiOptionKey: "batteryVoltageDuringCrankingObserved",
      },
    ],
  },
  {
    label: "Battery Cable",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "foundIntact",
      },
      {
        label: "+ve Terminal Found loose Contact",
        apiOptionKey: "positiveTerminalFoundLooseContact",
      },
      {
        label: "-ve Terminal Found loose Contact",
        apiOptionKey: "negativeTerminalFoundLooseContact",
      },
      {
        label: "Found +ve and -ve terminals interconnected",
        apiOptionKey: "foundPositiveAndNegativeTerminalInterconnected",
      },
    ],
  },
  {
    label: "Fuse Condition",
    options: [
      {
        label: "Found ok",
        apiOptionKey: "q4o1",
      },
      {
        label: "Found blown off",
        apiOptionKey: "foundBlownOff",
      },
    ],
  },
  electricalSystemDetails?.foundBlownOff && {
    label: "Blown off fuse",
    options: [
      {
        label: "5 AMPS",
        apiOptionKey: "5amps",
      },
      {
        label: "10 AMPS",
        apiOptionKey: "10amps",
      },
      {
        label: "15 AMPS",
        apiOptionKey: "15amps",
      },
      {
        label: "20 AMPS",
        apiOptionKey: "20amps",
      },
      {
        label: "30 AMPS",
        apiOptionKey: "30amps",
      },
      {
        label: "60 AMPS",
        apiOptionKey: "60amps",
      },
    ],
  },
  {
    label: "ECU Relay Condition",
    options: [
      {
        label: "Found ok",
        apiOptionKey: "q5o1",
      },
      {
        label: "Found loose",
        apiOptionKey: "foundLoose",
      },
      {
        label: "Found backout pins",
        apiOptionKey: "foundBackoutPins",
      },
    ],
  },
  {
    label: "ECU Response",
    options: [
      {
        label: "Connected to Diagnostic tool",
        apiOptionKey: "connectedToDiagnosticTool",
      },
      {
        label: "Not Connecting To Diagnostic Tool",
        apiOptionKey: "notConnectingToDiagnosticTool",
      },
      {
        label: "Connected But No Parameters Displayed",
        apiOptionKey: "connectedButNoParametersDisplayed",
      },
    ],
  },
  {
    label: "Wiring Harness",
    options: [
      {
        label: "All Connectors Are Intact",
        apiOptionKey: "allConnectorsAreIntact",
      },
      {
        label: "Found Burnt *",
        type: "INPUT",
        apiOptionKey: "foundBurnt",
      },
      {
        label: "Found harness damaged *",
        type: "INPUT",
        apiOptionKey: "foundHarnessDamaged",
      },
      {
        label: "Found tampered for external electrical systems *",
        type: "INPUT",
        apiOptionKey: "foundTamperedForExternalElectricalSystems",
      },
      {
        label: "Connector are interconnected between sensors *",
        type: "INPUT",
        apiOptionKey: "connectorAreInterconnectedBetweenSensors",
      },
    ],
  },
  {
    label: "ECU Grounding",
    options: [
      { label: "Found ok", apiOptionKey: "q9o1" },
      { label: "Grounding Not Provided", apiOptionKey: "groundingNotProvided" },
      {
        label: "Grounding provided but not as per recommendation",
        apiOptionKey: "groundingProvidedButNotAsPerRecommendation",
      },
    ],
  },
  {
    label: "Battery Charging Alternator",
    options: [
      { label: "Found ok", apiOptionKey: "q10o1" },
      { label: "Found faulty", apiOptionKey: "q10o2" },
    ],
  },

  {
    label: "Sensors Conditions",
    options: [
      { label: "Found ok", apiOptionKey: "q11o1" },
      {
        label: "Found faulty *",
        type: "INPUT",
        apiOptionKey: "q11o2",
      },
    ],
  },
  {
    label: "Actuators Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q12o1" },
      {
        label: "Found faulty *",
        type: "INPUT",
        apiOptionKey: "q12o2",
      },
    ],
  },
];

export const mappingDetailsToUIElectricalSystem = (details) => {
  const {
    batteryDetails = {},
    batteryCable = {},
    fuseCondition = {},
    blownOffFuse = {},
    ecuRelayCondition = {},
    ecuResponse = {},
    wiringHarness = {},
    ecuGrounding = {},
    batteryChargingAlternator = {},
    sensorCondition = {},
    actuatorsCondition = {},
  } = details;

  let responseDetails = {
    batteryStaticVoltageObserved: batteryDetails?.batteryStaticVoltageObserved,
    batteryVoltageDuringCrankingObserved:
      batteryDetails?.batteryVoltageDuringCranking,

    foundIntact: batteryCable?.foundIntact,
    positiveTerminalFoundLooseContact:
      batteryCable?.positiveTerminalFoundLooseContact,
    negativeTerminalFoundLooseContact:
      batteryCable?.negativeTerminalFoundLooseContact,
    foundPositiveAndNegativeTerminalInterconnected:
      batteryCable?.foundPositiveAndNegativeTerminalInterconnected,

    q4o1: fuseCondition?.foundOk,
    foundBlownOff: fuseCondition?.foundBlownOff,

    "5amps": blownOffFuse["5amps"],
    "10amps": blownOffFuse["10amps"],
    "15amps": blownOffFuse["15amps"],
    "20amps": blownOffFuse["20amps"],
    "30amps": blownOffFuse["30amps"],
    "60amps": blownOffFuse["60amps"],

    q5o1: ecuRelayCondition?.foundOk,
    foundLoose: ecuRelayCondition?.foundLoose,
    foundBackoutPins: ecuRelayCondition?.foundBackoutPins,

    connectedToDiagnosticTool: ecuResponse?.connectedToDiagnosticTool,
    notConnectingToDiagnosticTool: ecuResponse?.notConnectingToDiagnosticTool,
    connectedButNoParametersDisplayed:
      ecuResponse?.connectedButNoParametersDisplayed,

    allConnectorsAreIntact: wiringHarness?.allConnectorsAreIntact,
    foundBurnt: wiringHarness?.foundBurnt,
    foundHarnessDamaged: wiringHarness?.foundHarnessDamaged,
    foundTamperedForExternalElectricalSystems:
      wiringHarness?.foundTamperedForExternalElectricalSystems,
    connectorAreInterconnectedBetweenSensors:
      wiringHarness?.connectorAreInterconnectedBetweenSensors,

    q9o1: ecuGrounding?.foundOk,
    groundingNotProvided: ecuGrounding?.groundingNotProvided,
    groundingProvidedButNotAsPerRecommendation:
      ecuGrounding?.groundingProvidedButNotAsPerRecommendation,

    q10o1: batteryChargingAlternator?.foundOk,
    q10o2: batteryChargingAlternator?.foundFaulty,

    q11o1: sensorCondition?.foundOk,
    q11o2: sensorCondition?.foundFaulty,

    q12o1: actuatorsCondition?.foundOk,
    q12o2: actuatorsCondition?.foundFaulty,
  };

  return responseDetails;
};

export const infantChecklistElectricalSystem = (payload) => {
  const {
    batteryStaticVoltageObserved,
    batteryVoltageDuringCrankingObserved,

    foundIntact,
    positiveTerminalFoundLooseContact,
    negativeTerminalFoundLooseContact,
    foundPositiveAndNegativeTerminalInterconnected,

    q4o1,
    foundBlownOff,

    q5o1,
    foundLoose,
    foundBackoutPins,

    connectedToDiagnosticTool,
    notConnectingToDiagnosticTool,
    connectedButNoParametersDisplayed,

    allConnectorsAreIntact,
    foundBurnt,
    foundHarnessDamaged,
    foundTamperedForExternalElectricalSystems,
    connectorAreInterconnectedBetweenSensors,

    q9o1,
    groundingNotProvided,
    groundingProvidedButNotAsPerRecommendation,

    q10o1,
    q10o2,

    q11o1,
    q11o2,

    q12o1,
    q12o2,
  } = payload;

  const requestPayload = {
    batteryDetails: {
      batteryStaticVoltageObserved,
      batteryVoltageDuringCranking: batteryVoltageDuringCrankingObserved,
    },
    batteryCable: {
      foundIntact,
      positiveTerminalFoundLooseContact,
      negativeTerminalFoundLooseContact,
      foundPositiveAndNegativeTerminalInterconnected,
    },
    fuseCondition: {
      foundOk: q4o1,
      foundBlownOff,
    },
    blownOffFuse: {
      "5amps": payload["5amps"],
      "10amps": payload["10amps"],
      "15amps": payload["15amps"],
      "20amps": payload["20amps"],
      "30amps": payload["30amps"],
      "60amps": payload["60amps"],
    },
    ecuRelayCondition: {
      foundOk: q5o1,
      foundLoose,
      foundBackoutPins,
    },
    ecuResponse: {
      connectedToDiagnosticTool,
      notConnectingToDiagnosticTool,
      connectedButNoParametersDisplayed,
    },
    wiringHarness: {
      allConnectorsAreIntact,
      foundBurnt,
      foundHarnessDamaged,
      foundTamperedForExternalElectricalSystems,
      connectorAreInterconnectedBetweenSensors,
    },
    ecuGrounding: {
      foundOk: q9o1,
      groundingNotProvided,
      groundingProvidedButNotAsPerRecommendation,
    },
    batteryChargingAlternator: {
      foundOk: q10o1,
      foundFaulty: q10o2,
    },
    sensorCondition: {
      foundOk: q11o1,
      foundFaulty: q11o2,
    },
    actuatorsCondition: {
      foundOk: q12o1,
      foundFaulty: q12o2,
    },
  };

  return removeUndefinedFields(requestPayload);
};
